import React from 'react';
import * as yup from 'yup';

import { MultiStepForm } from '../../../components';
import { Steps } from 'react-step-builder';
import { AddOnForm } from '.';
import { useAddOnEdit, useAddOnValidationSchema } from '../hooks';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { usePolicyPricingOptions } from '../../../components/sharedComponents/pricing';
import { useFormOptions } from '../../../hooks';
import { CustomDataStep } from '../../productCreateUpdate/components';

export default function AddOnEdit({ policy, addOns }) {
  const history = useHistory();
  const validationSchema = useAddOnValidationSchema();
  const { selectOptions } = usePolicyPricingOptions({ policyId: policy?.id });

  const { addOnId } = useParams();

  const addOn = addOns?.find(x => x.id === addOnId);
  const { loading, error, initialValues, handleSubmit } = useAddOnEdit({
    addOn,
    onCompleted: () => history.goBack(),
    selectOptions,
    policyId: policy?.id
  });
  const formOptions = useFormOptions({
    options: [{ name: 'pricingSelectOptions', options: selectOptions }]
  });

  return (
    <MultiStepForm
      title="Update Add-On"
      formOptions={formOptions}
      formSteps={[
        { name: 'Add-On Details', initialValues, validationSchema },
        {
          name: 'Add-On Custom Data',
          initialValues: { customData: addOn?.customData },
          validationSchema: yup.object().shape({
            customData: yup.object()
          })
        }
      ]}
      formSubmit={handleSubmit}
      onCancel={() => history.goBack()}
      submitButtonText="Create Add-On"
      submitButtonProps={{ loading, loadingText: 'Updating...' }}
      showButtonsOnBottom
      error={error}
    >
      {formProps => (
        <>
          <Steps>
            <AddOnForm {...formProps} />
            <CustomDataStep title="Add-On Custom Data" {...formProps} />
          </Steps>
        </>
      )}
    </MultiStepForm>
  );
}
